import MembershipModule from "./membershipModule";
import MembershipSagas from "./redux/membershipSagas";
import MembershipReducer from "./redux/membershipReducer";

export default {
  Component: MembershipModule,
  moduleName: "membership",
  saga: MembershipSagas(),
  reducer: MembershipReducer
};
